import { render, staticRenderFns } from "./LeadAppointmentHistory.vue?vue&type=template&id=64b35a7a&scoped=true"
import script from "./LeadAppointmentHistory.vue?vue&type=script&lang=js"
export * from "./LeadAppointmentHistory.vue?vue&type=script&lang=js"
import style0 from "./LeadAppointmentHistory.vue?vue&type=style&index=0&id=64b35a7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b35a7a",
  null
  
)

export default component.exports